import {
	MATCH_SQUAD_TOGGLE_EDIT,
	MATCH_SQUAD_FETCH,
	MATCH_SQUAD_FETCH_SUCCESS,
	MATCH_SQUAD_UPDATE_SUCCESS,
	MATCH_SQUAD_REVIEW_CHANGE,
	MATCH_SQUAD_GOAL_CHANGE,
	MATCH_SQUAD_CARD_CHANGE,
	MATCH_SQUAD_POSITION_CHANGE,
	MATCH_SQUAD_RATING_CHANGE,
	MATCH_SQUAD_AVG_RATING_CHANGE,
	MATCH_SQUAD_ADD_PLAYER,
	MATCH_SQUAD_ADD_PLAYER_SUCCESS,
	MATCH_SQUAD_ADD_PLAYER_FAIL,
	MATCH_SQUAD_INPUT_PLAYER,
	MATCH_SQUAD_INPUT_POSITION,
	MATCH_SQUAD_INPUT_GOAL,
	MATCH_SQUAD_INPUT_CARD,
	MATCH_SQUAD_INPUT_MATCH_RATING,
	MATCH_SQUAD_INPUT_REVIEW,
	MATCH_SQUAD_DELETE_PLAYER_SUCCESS,
	USER_RATING_ADD_SUCCESS,
	USER_RATING_ADD_FAIL,
} from '../actions/types';

const INITIAL_STATE = {
	loading: false,
	inputPlayer: '',
	inputPosition: '',
	inputGoal: 0,
	inputCard: 0,
	inputMatchRating: 0,
	inputReview: '',
	inputLoading: false,
	list: {},
	errorText: '',
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case MATCH_SQUAD_REVIEW_CHANGE:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								onChange: {
									...state.list[action.id].squad[action.payload.position].onChange,
									review: action.payload.text,
								},
							},
						},
					},
				},
			};
		case MATCH_SQUAD_POSITION_CHANGE:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								onChange: {
									...state.list[action.id].squad[action.payload.position].onChange,
									position: action.payload.value,
								},
							},
						},
					},
				},
			};
		case MATCH_SQUAD_RATING_CHANGE:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								onChange: {
									...state.list[action.id].squad[action.payload.position].onChange,
									matchRating: action.payload.value,
								},
							},
						},
					},
				},
			};
		case MATCH_SQUAD_AVG_RATING_CHANGE:
			let copyList = Object.assign({}, state.list);
			copyList[action.id] = {
				...copyList[action.id],
			};

			if (typeof copyList[action.id].squad === 'undefined') {
				copyList[action.id].squad = {};
			}

			copyList[action.id].squad = {
				...copyList[action.id].squad,
				[action.payload.position]: {
					...copyList[action.id].squad[action.payload.position],
					...action.payload,
				},
			};
			return {
				...state,
				list: copyList,
			};
		case MATCH_SQUAD_GOAL_CHANGE:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								onChange: {
									...state.list[action.id].squad[action.payload.position].onChange,
									goals: action.payload.value,
								},
							},
						},
					},
				},
			};
		case MATCH_SQUAD_CARD_CHANGE:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								onChange: {
									...state.list[action.id].squad[action.payload.position].onChange,
									cards: action.payload.value,
								},
							},
						},
					},
				},
			};
		case MATCH_SQUAD_TOGGLE_EDIT:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload]: {
								...state.list[action.id].squad[action.payload],
								readOnly: !state.list[action.id].squad[action.payload].readOnly,
								onChange: {
									matchRating: state.list[action.id].squad[action.payload].matchRating,
									cards: state.list[action.id].squad[action.payload].cards,
									goals: state.list[action.id].squad[action.payload].goals,
									playerDoc: state.list[action.id].squad[action.payload].playerDoc,
									userRating: state.list[action.id].squad[action.payload].userRating,
									position: state.list[action.id].squad[action.payload].position,
									review: state.list[action.id].squad[action.payload].review,
								},
							},
						},
					},
				},
			};
		case MATCH_SQUAD_UPDATE_SUCCESS:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								...action.payload,
								readOnly: true,
								onChange: action.payload,
							},
						},
					},
				},
			};
		case MATCH_SQUAD_FETCH:
			return { ...state, loading: true, errorText: '' };
		case MATCH_SQUAD_FETCH_SUCCESS:
			return {
				...state,
				loading: false,
				list: { ...state.list, [action.id]: { ...state.list[action.id], squad: action.payload } },
			};

		case MATCH_SQUAD_INPUT_PLAYER:
			return { ...state, inputPlayer: action.payload };
		case MATCH_SQUAD_INPUT_POSITION:
			return { ...state, inputPosition: action.payload };
		case MATCH_SQUAD_INPUT_GOAL:
			return { ...state, inputGoal: action.payload };
		case MATCH_SQUAD_INPUT_CARD:
			return { ...state, inputCard: action.payload };
		case MATCH_SQUAD_INPUT_MATCH_RATING:
			return { ...state, inputMatchRating: action.payload };
		case MATCH_SQUAD_INPUT_REVIEW:
			return { ...state, inputReview: action.payload };

		case MATCH_SQUAD_ADD_PLAYER:
			return { ...state, inputLoading: true };
		case MATCH_SQUAD_ADD_PLAYER_FAIL:
			return { ...state, inputLoading: false };
		case MATCH_SQUAD_ADD_PLAYER_SUCCESS:
			return {
				...state,
				inputPlayer: ' ',
				inputPosition: ' ',
				inputGoal: 0,
				inputCard: 0,
				inputMatchRating: 0,
				inputReview: '',
				inputLoading: false,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							...action.payload,
						},
					},
				},
			};
		case MATCH_SQUAD_DELETE_PLAYER_SUCCESS:
			const copyDelete = Object.keys(state.list[action.id].squad).reduce((obj, key) => {
				if (state.list[action.id].squad[key].playerDoc !== action.payload) {
					return { ...obj, [key]: state.list[action.id].squad[key] };
				}
				return obj;
			}, {});
			return {
				...state,

				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: copyDelete,
					},
				},
			};
		case USER_RATING_ADD_SUCCESS:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								userVoted: true,
								userRating: action.userRating,
							},
						},
					},
				},
			};
		case USER_RATING_ADD_FAIL:
			return {
				...state,
				list: {
					...state.list,
					[action.id]: {
						...state.list[action.id],
						squad: {
							...state.list[action.id].squad,
							[action.payload.position]: {
								...state.list[action.id].squad[action.payload.position],
								userVoted: action.payload.userVoted,
							},
						},
					},
				},
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/MatchSquadReducer.js